import * as axios from 'axios';

function upload(formData, intentIdExternal) {
  const url = 'v1/knowledge/attachment/item/' + intentIdExternal;
  return axios.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
    // get data
    .then(x => x.data)
    // add url field
    // .then(x => x.map(img => Object.assign({},
    //   img, { url: `${BASE_URL}/images/${img.id}` })));
}

export { upload }